import { useTellescopeQuery } from "@tellescope/tanstack-query";
import { formatFileSize } from "@tellescope/utils";
import { CarePlanFilePreview } from "./CarePlanFilePreview";

export interface CarePlanFileItemProps {
  id: string;
}

export const CarePlanFileItem = ({ id }: CarePlanFileItemProps) => {
  const fileQuery = useTellescopeQuery({
    model: "files",
    method: "getOne",
    request: id,
    enabled: !!id,
  });

  const file = fileQuery.data;
  if (!file) return null;

  return (
    <>
      <CarePlanFilePreview file={file} size={32} />
      <p className="text-sm truncate">{file.name}</p>
      <span className="text-xs text-muted-foreground flex-shrink-0 font-light">{`(${formatFileSize(file.size)})`}</span>
    </>
  );
};
